//LoginView.vue



<template>

  <div>

	<div id="background">
		<!-- <img id="project-image" :src="'imgs/projects/snohetta.jpg'" /> -->
		<!-- <img id="project-image" :src="'imgs/projects/antwerpen1.jfif'" /> -->
		<img id="project-image" :src="'imgs/projects/Background1.jpg'" />

		<!-- <img id="project-image" :src="'imgs/projects/dujardin.jpg'" /> -->
		<!-- <img id="project-image" :src="'imgs/projects/mainzerobg.jpg'" /> -->
	</div>

	<div id="header">
		<HeaderBasic />
	</div> 

	<div class="center">
        <h1>Login</h1>
		<form>
		<!-- <form method="post"> -->
			<!-- Username -->
			<div class="text_field">
				<input type="text" required v-model="username">
				<span></span>
				<label>Username</label>
			</div>
			<!-- Password -->
			<div class="text_field">
				<input type="password" required v-model="password">
				<span></span>
				<label>Password</label>
			</div>
			<!-- Forget Password -->
			<div class="pass" @click="requestLogin">
				Forgot Password?
			</div>
			<!-- Login Button -->
			<input type="submit" name="username" value="Login" @click="login"/>

			<!-- Signup -->
			<div class="signup_link" @click="requestLogin">
				Not registered? <a href="#">   Request login</a>
			</div>
		</form>
    </div> 

  </div>

</template>

<script>


import HeaderBasic from "../components/HeaderBasic.vue";
import * as authentification from "../authentification.js";


export default {
	name: 'Login', 
	components: {
		HeaderBasic,
	},
	data() {
		return {
			msg: "",
			username: "",
			password: ""
		};
	},
	methods: {
		login() {	
			
			//Check if user is authenticated user
			if(authentification.authenticateUser(this.password, this.username)) {
				var loggedInStatus = JSON.stringify('loggedIn');
				localStorage.setItem('loggedInStatus', loggedInStatus); 
				
				//Check if user is admin
				if(authentification.authenticateAdmin(this.password, this.username)) {
					var adminStatus = JSON.stringify('admin');
					localStorage.setItem('adminStatus', adminStatus); 
					console.log("User is admin");
				}
				else {
					console.log("User is NOT admin");
				}


				this.$router.replace({ name: "Calculate" });
			}
			else {
				alert("User or password not correct"); 
			}

			//Log result
			console.log('loggedInStatus', loggedInStatus);
			console.log('adminStatus', adminStatus);
		},
		requestLogin() {
			var email = document.createElement("a");
			email.href = "mailto:nhaschke@bollinger-grohmann.de";
			email.click();
		}
    }
};
</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


#background {
	top: 0;
	left: 0;
	height: 100vh;
	width: 100vw;
	background: rgba(145, 145, 145, 0.2);
	position: absolute;
	background-image: linear-gradient(rgba(220, 220, 222, 1),rgba(194, 194, 207, 0.8));
}

#view-title {
	top:10%;
	left: 10%;
	position: fixed;
	color: black;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
	font-weight: 200;
	text-align: left;
	margin-left: 30px;
	padding-top: 20px;
}

#project-image {
	/* height: 100vh; */
	width: 100vw;
	top: 0%;
	left: 0%;
	position: fixed;
	opacity: .05;
}

#header {
	position: fixed;
	top: 2%;
}

#uploadButton {
	position: fixed;
	top: 93%;
	left: 47%;
}

#login {
	position: fixed;
	top: 13%;
	left: 17%;
	width: 500px;
	border: 1px solid #CCCCCC;
	background-color: #FFFFFF;
	margin: auto;
	margin-top: 200px;
	padding: 20px;
}




/* ------------------------------------------------
Login
 -------------------------------------------------- */

.center {
	position: absolute;
	top: 50%;
	left: 50%;
	transform:  translate(-50%, -50%);
	width: 400px;
	background: white;
	border-radius: 10px;
}

.center h1 {
	text-align: center;
	padding: 0 0 20px 0;
	border-bottom: 1px solid silver;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
}

.center form {
	padding: 0 40px;
	box-sizing: border-box;
}

form .text_field {
	position: relative;
	border-bottom: 2px solid #adadad;
	margin: 30px 0;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
}

.text_field input {
	width: 100%;
	padding:  0 5px;
	height: 40px;
	font-size: 16px;
	border: none;
	background: none;
	outline:none; 
}

.text_field label {
	position: absolute;
	top: 50%;
	left: 5px;
	color: #adadad;
	transform: translateY(-50%);
	font-size: 16px;
	pointer-events: none;
	transition: .5s;
}

.text_field span::before {
	content: '';
	position: absolute;
	top: 40px;
	left: 0;
	width: 0%;
	height: 2px;
	background: #2691d9;
	transition: .5s;
}

.text_field input:focus ~ label,
.text_field input:valid ~ label {
	top: -5px;
	color: #2691d9;
}

.text_field input:focus ~ span::before,
.text_field input:valid ~ span::before {
	width: 100%;
}

.pass{
	margin: -5px 0 20px 5px;
	color: #a6a6a6;
	cursor: pointer;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
}

.pass:hover{
	text-decoration: underline;
}

#login-button {
	width: 100px;
	height: 50px;
	border: 1px solid;
	background: #2691d9;
	border-radius: 25px;
	font-size: 18px;
	color: #e9f4fb;
	font-weight: 700;
	cursor: pointer;
	outline: none;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
	position: absolute;
	top: 80%;
	left: 50%;
	transform:  translate(-50%, -50%);
}

#login-button:hover {
	border-color: #2691d9;
	transition: .5s;
}

#test-button {
	width: 100px;
	height: 50px;
	border: 1px solid;
	background: #2691d9;
	border-radius: 25px;
	font-size: 18px;
	color: #e9f4fb;
	font-weight: 700;
	cursor: pointer;
	outline: none;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
	position: absolute;
	top: 89%;
	left: 50%;
	transform:  translate(-50%, -50%);
}

input[type="submit"] {
	width: 100%;
	height: 50px;
	border: 1px solid;
	background: #2691d9;
	border-radius: 25px;
	font-size: 18px;
	color: #e9f4fb;
	font-weight: 700;
	cursor: pointer;
	outline: none;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
}

input[type="submit"]:hover {
	border-color: #2691d9;
	transition: .5s;
}

.signup_link {
	margin: 30px 0;
	text-align: center;
	font-size: 16px;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
	color: #666666;
}

.signup_link a{
	color: #2691d9;
	text-decoration: none;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
}

.signup_link a:hover{
	color: #2691d9;
	text-decoration: underline;
}

</style>









